export type SubCategoryItem = {
  value: string
  text: string
}

export const SubCategoryValues: SubCategoryItem[] = [
  { value: 'Control And Coordination', text: 'Control And Coordination' },
  { value: 'HSE, Quantity And Risk', text: 'HSE, Quantity And Risk' },
  { value: 'Procedures And Method Statements', text: 'Procedures And Method Statements' },
  { value: 'Drawings, Instructions And Data', text: 'Drawings, Instructions And Data' },
  { value: 'Reports', text: 'Reports' },
  { value: 'Cable Route Information', text: 'Cable Route Information' },
  { value: 'Spares', text: 'Spares' },
  { value: 'Permits', text: 'Permits' },
  { value: 'Sub Contractor Civil Work Onshore', text: 'Sub Contractor Civil Work Onshore' }
]
